import 'angular:locale/data:pt';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "pt";
